<template>
  <div class="stock-notifications-spinner" :class="{ sm: sm, md: md, slim: slim }" :style="computedStyle"></div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '', // Default color can be changed as needed
    },
    md: {
      type: Boolean,
      default: false, // Use this prop to control the size of the spinner
    },
    sm: {
      type: Boolean,
      default: false, // Use this prop to control the size of the spinner
    },
    slim: {
      type: Boolean,
      default: false, // Use this prop to control the border width of the spinner
    },
    animationDuration: {
      type: String,
      default: '1s', // Default animation duration in seconds
    },
    size: {
      type: String,
      default: '40px', // Default size of the spinner
    },
    // md: {
    //   type: Boolean,
    //   default: false
    // },
  },
  computed: {
    computedStyle() {
      const style = {};
      if (this.color) {
        style['--spinner-color'] = this.color;
        // return { '--spinner-color': this.color };
      }
      if (this.animationDuration) {
        style['animation-duration'] = this.animationDuration;
      }
      if (this.size) {
        style.width = this.size;
        style.height = this.size;
      }
      return style;
    },
  },
}
</script>

<style scoped>
.stock-notifications-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: var(--spinner-color, currentColor);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  display: inline-block;
  flex: 0 0 auto;
  margin: 0;
  vertical-align: middle;
}

.stock-notifications-spinner.sm {
  width: 20px;
  height: 20px;
}

.stock-notifications-spinner.md {
  width: 30px;
  height: 30px;
}

.stock-notifications-spinner.slim {
  border-width: 3px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
